import { Component, Input, OnInit } from '@angular/core';
import { BillingStoreService } from '@app/home/store/billing-store.service';

@Component({
  selector: 'app-cyber-quote',
  templateUrl: './cyber-quote.component.html',
  styleUrls: ['./cyber-quote.component.scss'],
  standalone: false,
})
export class CyberQuoteComponent implements OnInit {
  // @Input() isCyberFlow: boolean = false;

  product: string = 'Cyber ';
  company: string = 'Arch Insurance Company';

  constructor(private billingStoreService: BillingStoreService) {}

  ngOnInit(): void {
    // If not set via Input, check the BillingStoreService
    // if (!this.isCyberFlow) {
    //   this.isCyberFlow = this.billingStoreService.isCyberFlow();
    // }
    // console.log('CyberQuoteComponent - isCyberFlow:', this.isCyberFlow);
  }
}
